/**
 * Converts timestamp to EWS request date string
 */
export default function getEwsRequestDateString(timeStamp) {
    return timeStamp ? new Date(timeStamp).toISOString() : null;
}
//# sourceMappingURL=getEwsRequestDateString.js.map